import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box } from "@mui/material"

import { getProductcompositionStruct, setData } from './ProductcompositionStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './ProductcompositionAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updateProductcompositionObj, addProductcompositionObj, setShowEditForProductcomposition, setProductManagecompositionModal } from 'store/slice/PharmaSlice';




export default function ProductcompositionEditFormImpl() {
    const dispatch = useDispatch();
    const { setNotification, lastURL } = React.useContext(CoreContext);
    const [formValues, setFormValues] = useState(getProductcompositionStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const { productcompositionDashboard, productDashboard } = useSelector((state) => state.pharmaslice);
    const [productcompositionId, setProductcompositionId] = useState(productcompositionDashboard.selectedId);

    const { compositionList } = useSelector((state) => state.pharmaslice);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo)
    const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard)


    const handleDynamicSelectedValueForcompositionid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'compositionname', compositionList.find(obj => obj.id === e.target.value).name);
    }

    useEffect(() => {
        if (productcompositionId !== -1) {
            if (dataLoaded) return;
            getAPI(productcompositionId, loadForm);
        }
        else {
            // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }
        console.log('businessid=>' + businessid);
        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            },
            ['productid']: {
                ...formValues['productid'],
                value: productDashboard.selectedId
            },
            ['orderid']: {
                ...formValues['orderid'],
                value: pharmaorderObj.orderid
            },

        })
    }, []);

    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value + " == " + getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        updateTextValue(formValues, setFormValues, e);
    }

    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(addProductcompositionObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForProductcomposition(false));
        //dispatch(setProductManagecompositionModal(false));
    }
    const updateSuccessCallback = (obj) => {
        //dispatch(updateProductcompositionObj(obj));
        setNotification('Record with id[' + productcompositionId + '] has been updated successfully !!!');
        dispatch((false));

    }
    const failuerCallback = (errorMsg) => {
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const onSubmit = (e) => {
        handleSubmit(e, productcompositionId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, createAPI, updateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);
        var dateStrArray = date.toLocaleDateString().split('/');
        var dateStr = dateStrArray[2] + "-" + dateStrArray[1] + "-" + dateStrArray[0] + "T00:00:00.000+00:00";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: 440 }}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{productcompositionId === -1 ? 'Add' : 'Edit'} Composition</Typography>
                                <Divider />
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center">

                                    <Grid item lg={8} xs={12}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">Composition Name</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.compositionid.label}
                                                name={formValues.compositionid.name}
                                                value={formValues.compositionid.value}
                                                onChange={handleDynamicSelectedValueForcompositionid}

                                                error={formValues.compositionid.error}
                                                helpertext={formValues.compositionid.error && formValues.compositionid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Item</MenuItem>
                                                {
                                                    compositionList && compositionList.map((item, i) => <MenuItem key={i} value={item.id}>{item.name}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.quantity.placeholder}
                                            required={formValues.quantity.required}
                                            label={formValues.quantity.label}
                                            name={formValues.quantity.name}
                                            value={formValues.quantity.value}
                                            onChange={handleTextChange}
                                            error={formValues.quantity.error}
                                            helpertext={formValues.quantity.error && formValues.quantity.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.productid.placeholder}
                                            required={formValues.productid.required}
                                            label={formValues.productid.label}
                                            name={formValues.productid.name}
                                            value={formValues.productid.value}
                                            onChange={handleTextChange}
                                            error={formValues.productid.error}
                                            helpertext={formValues.productid.error && formValues.productid.errorMessage}
                                            sx={{ width: '100%', display: 'none' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.compositionname.placeholder}
                                            required={formValues.compositionname.required}
                                            label={formValues.compositionname.label}
                                            name={formValues.compositionname.name}
                                            value={formValues.compositionname.value}
                                            onChange={handleTextChange}
                                            error={formValues.compositionname.error}
                                            helpertext={formValues.compositionname.error && formValues.compositionname.errorMessage}
                                            sx={{ width: '100%', display: 'none' }}
                                        />
                                    </Grid>



                                    <Grid item lg={4} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%', display: 'none' }}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.orderid.placeholder}
                                    required={formValues.orderid.required}
                                    label={formValues.orderid.label}
                                    name={formValues.orderid.name}
                                    value={formValues.orderid.value}
                                    onChange={handleTextChange}
                                    error={formValues.orderid.error}
                                    helpertext={formValues.orderid.error && formValues.orderid.errorMessage}
                                    sx={{ width:'100%', display:'none'}}
                                />
                            </Grid>

                                </Grid>
                                : <></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid >
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    <Button type="submit" >{productcompositionId === -1 ? 'Add' : 'Save'}</Button>
                    <Button onClick={() => { dispatch(setShowEditForProductcomposition(false));  }}>Close</Button>
                </Grid>
            </Grid>
        </form>
    );
};